import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Stack from "react-bootstrap/Stack";
import { Container, Tabs, Tab, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import Result from "../dashboard/Result";
import AllDashBoardsDetails from "./Summary/AllDashBoardsDetails";

interface AddNewProps {
  userData: any;
  action: string;
  tabState: string;
  selctedyear: number;
}

const DoctorSchedule: React.FC<AddNewProps> = ({
  userData,
  action,
  tabState,
  selctedyear,
}) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);

  const [activeTab, setActiveTab] = useState<string>(tabState || "Summary");
  const { InterVal, actionType } = useSelector(
    (state: RootState) => state.DashBoardStage,
  );
  const handleTabChange = (tab: string | null) => {
    if (tab) setActiveTab(tab);
  };

  const handleCaseActionTabChange = (tab: string | null) => {
    setActiveTab("Result");
  };

  return (
    <div>
      {/* Header Section */}
      <div className="breadcrumbg pb-0">
        <Container fluid className="px-5">
          <Stack direction="horizontal" gap={2}>
            <Col className="pt-0 flex-column d-flex align-items-start fade-in-left">
              <h4>DASHBOARD</h4>

              {/* Main Tabs */}
              <Tabs
                activeKey={activeTab}
                onSelect={handleTabChange}
                className="mb-0 Tab_borderBottom fade-in-left"
              >
                <Tab eventKey="Summary" title="Summary" />
                {/* <Tab eventKey="Case Actions" title="Case Actions" />
                <Tab eventKey="Insights" title="Insights" /> */}
                <Tab eventKey="Result" title="Result" />
              </Tabs>
            </Col>
          </Stack>
        </Container>
      </div>

      {/* Content Section */}
      <div className="main_wrapper_section pills_wrapper">
        <Container fluid className="mt-3">
          {activeTab === "Summary" && (
            <Col md={12}>
              <div className="min-h-screen p-8 bg-gray-50">
                {" "}
                <AllDashBoardsDetails
                  onTabChange={() => handleTabChange("Result")}
                />
              </div>
            </Col>
          )}

          {activeTab === "Case Actions" && (
            <Col md={12}>
              <div>This is the Case Actions tab.</div>
            </Col>
          )}

          {activeTab === "Insights" && (
            <Col md={12}>
              <div>This is the Insights tab.</div>
            </Col>
          )}

          {activeTab === "Result" && (
            <Col md={12}>
              <Result />
            </Col>
          )}
        </Container>
      </div>
    </div>
  );
};

export default DoctorSchedule;
